/**
 * Meta Pixel (Facebook Pixel) — Client-side event helpers
 * Pixel ID: 1308028040250900
 *
 * ESTADO REAL (atualizado em 02/08/2026):
 * - Todas as funções `mp*` abaixo estão NEUTRALIZADAS (no-op). As assinaturas
 *   foram mantidas apenas para não quebrar imports existentes.
 * - `Purchase` vem EXCLUSIVAMENTE da integração nativa da Shopify (Web Pixel do
 *   checkout + CAPI, data sharing "Máximo"), que deduplicam entre si por um
 *   event_id interno não exposto. Nenhum código nosso envia Purchase ao Meta.
 * - `ViewContent`, `AddToCart` e `InitiateCheckout` saem pela edge function
 *   `meta-capi` (server-side).
 * - O GTM (GTM-KGGTZRWN) NÃO é fonte de eventos Meta: o container live não tem
 *   nenhuma tag de Facebook ativa (a única existente está pausada).
 * - O init do pixel permanece no index.html, carregado só após o consentimento.
 *
 * NÃO reativar `fbq('track')` aqui sem antes auditar as fontes acima — foi assim
 * que o Purchase chegou a ser contado 3×.
 */


declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
  }
}

function fbq(...args: unknown[]): void {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return;
  window.fbq(...args);

  if (import.meta.env.DEV) {
    console.log('[Meta Pixel]', ...args);
  }
}

// ─── Standard Events ────────────────────────────────────────────────────────

export function mpViewContent(params: {
  content_ids: string[];
  content_name: string;
  content_type?: string;
  value: number;
  currency?: string;
  event_id?: string;
}): void {
  return;
}

export function mpAddToCart(params: {
  content_ids: string[];
  content_name: string;
  value: number;
  currency?: string;
  event_id?: string;
}): void {
  return;
}

export function mpInitiateCheckout(params: {
  value: number;
  num_items: number;
  currency?: string;
  event_id?: string;
}): void {
  return;
}

export function mpPurchase(params: {
  content_ids: string[];
  value: number;
  currency?: string;
  num_items?: number;
  event_id?: string;
}): void {
  return;
}

export function mpPageView(): void {
  return;
}

export function mpLead(params?: {
  content_name?: string;
  event_id?: string;
}): void {
  return;
}
